import { GET_MY } from "../../containers/App/constants";
import { LOGIN_REGISTER } from "./constants";

export function register(email,password,callback){
  return {
    type : GET_MY,
    post: {email,password},
    path : `public/register`,
    work : LOGIN_REGISTER,
    gate : LOGIN_REGISTER,
    callback
  }
}